import type { ReactNode } from "react";

interface InfoBoxProps {
  variant?: "info" | "warning" | "error" | "success" | "gray";
  children: ReactNode;
  className?: string;
}

export function InfoBox({
  variant = "info",
  children,
  className = "",
}: InfoBoxProps) {
  const variants = {
    info: "bg-blue-50 border-blue-200 text-blue-900",
    warning: "bg-yellow-50 border-yellow-200 text-yellow-900",
    error: "bg-red-50 border-red-200 text-red-900",
    success: "bg-green-50 border-green-200 text-green-900",
    gray: "bg-gray-50 border-gray-200 text-gray-700",
  };

  return (
    <div
      className={`${variants[variant]} border rounded-md p-4 text-sm ${className}`}
    >
      {children}
    </div>
  );
}
